import { AxiosError } from 'axios'
import { useFeedback } from 'context'
import { ApiResponseTypes, ReportsServices } from 'services'
import { useInfiniteQuery } from 'react-query'

import { useParamsSelector } from 'hooks'
import { getNextPageParam } from 'utils/getNextParam'
import { UseQueryOptionsTypes } from '../../queries.types'

export const useInfiniteAssignmentsStudentsQuery = (
  options: UseQueryOptionsTypes | undefined = {}
) => {
  const { useParams, enabled } = options

  const params = useParamsSelector()

  const queryParams = useParams ? params.objParams : {}

  const { alert } = useFeedback()

  const { data, ...infiniteQuery } = useInfiniteQuery(
    ['v2/reports/assignments', queryParams],
    (paginatedParams) => {
      return ReportsServices.assignments.paginated({
        params: {
          page: paginatedParams.pageParam || 1,
          search: queryParams.searchAssignment || queryParams.search,
          userGroupId: queryParams.userGroupId,
          orderType: queryParams.orderType,
          orderBy: queryParams.orderBy
        }
      })
    },
    {
      keepPreviousData: true,
      getNextPageParam,
      onError: (error: AxiosError<ApiResponseTypes<unknown>>) => {
        alert.showError(error.response?.data.message || error.message)
      },
      enabled,
      cacheTime: 0
    }
  )

  return {
    data: data?.pages.flatMap((page) => page.data) || [],
    dataCount: data?.pages.flatMap((page) => page.pagination.dataCount)[0] || 0,
    ...infiniteQuery
  }
}
